import { Component, ErrorInfo, ReactNode } from 'react';
import posthog from 'posthog-js';

interface Props {
    children: ReactNode;
    fallback?: ReactNode;
}

interface State {
    hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
    state: State = { hasError: false };

    static getDerivedStateFromError(): State {
        return { hasError: true };
    }

    componentDidCatch(error: Error, info: ErrorInfo): void {
        posthog.captureException(error, {
            react_component_stack: info.componentStack,
        });
    }

    render(): ReactNode {
        if (this.state.hasError) {
            return this.props.fallback ?? <div className="p-6">Something went wrong.</div>;
        }
        return this.props.children;
    }
}
